import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Home_about from "./home-about/Home_about";
import Related_category from "./related-category/Related_category";
import Why_clients from "./why-clients/Why_clients";
import Services from "./services/Services";
import Enquire_now from "./enquire_now/Enquire_now";
import All_video from "./all-video/All_video";

function Home() {
  return (
    <>
      <Banner />
      <Services />
      <Home_about />
      <Related_category />
      <Enquire_now />
      <All_video />
      <Why_clients />
    </>
  );
}

export default Home;
